import { render, staticRenderFns } from "./EventParticipantForm.vue?vue&type=template&id=c3dc5e80"
import script from "./EventParticipantForm.vue?vue&type=script&lang=js"
export * from "./EventParticipantForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports